const defaultResolver = {
  defaults: {
    app: {
      __typename: "AppSetting",
      ordno: 0,
      passwordCheck: false
    }
  }
};

export default defaultResolver;



// WEBPACK FOOTER //
// ./src/resolvers/default.resolver.ts